import { type StateCreator } from 'zustand';

import { ONE_MINUTE } from '@air/utilities';

export type PendingEmailCooldownSlice = {
  endsAt: number;
  start: () => void;
  clear: () => void;
};

export const createPendingEmailCooldownSlice: StateCreator<
  PendingEmailCooldownSlice,
  [],
  [],
  PendingEmailCooldownSlice
> = (set) => ({
  endsAt: 0,
  start: () => set({ endsAt: Date.now() + ONE_MINUTE }),
  clear: () => set({ endsAt: 0 }),
});
